import { getToday, isBefore, diff, NO_END, DateRange } from '@ha/date';

interface AvailabilityMetrics {
  available_in: number;
  available_for: number;
  all_availabilities: DateRange[];
}

const getAvailableIn = (bookablePeriods: DateRange[]) => {
  if (bookablePeriods.length === 0) {
    return -1;
  }

  const firstBookableDay = bookablePeriods[0].from;
  const today = getToday();

  if (isBefore(firstBookableDay, today) || firstBookableDay === today) {
    return 0;
  }

  return diff('day', bookablePeriods[0].from, getToday());
};

const getAvailableFor = (bookablePeriods: DateRange[]) => {
  if (bookablePeriods.length === 0) {
    return 0;
  }

  if (bookablePeriods[0].to === NO_END) {
    return 9999;
  }

  const firstBookableDay = bookablePeriods[0].from;
  const today = getToday();

  if (isBefore(firstBookableDay, today)) {
    return diff('day', bookablePeriods[0].to, getToday());
  }

  return diff('day', bookablePeriods[0].to, firstBookableDay);
};

const getAvailabilityMetrics = (
  bookablePeriods: DateRange[],
): AvailabilityMetrics => ({
  all_availabilities: bookablePeriods,
  available_for: getAvailableFor(bookablePeriods),
  available_in: getAvailableIn(bookablePeriods),
});
export { getAvailabilityMetrics };
